import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=162a2870&scoped=true&"
import script from "./SSOLogin.vue?vue&type=script&lang=js&"
export * from "./SSOLogin.vue?vue&type=script&lang=js&"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=162a2870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../Valuation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a2870",
  null
  
)

/* custom blocks */
import block0 from "./SSOLogin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports